module.exports = __webpack_public_path__ + "images/6633b973534a9a2e3e54ff287686d8f5-IMG_9406.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/bedroom/IMG_9406.jpg
// module id = ./src/assets/images/slides/bedroom/IMG_9406.jpg
// module chunks = 0